(() => {
  function init(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';
    const slides = [...root.querySelectorAll('[data-lf-slide]')];
    if (!slides.length) return;
    const dots = [...root.querySelectorAll('[data-lf-carousel-dot]')];
    const video = root.querySelector('video');
    const videoSlideIndex = video ? slides.findIndex(slide => slide.contains(video)) : -1;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = navigator.connection?.saveData;
    let active = 0, timer, focused = false, visible = true;
    let automatic = !reduce.matches;
    function hydrate() {
      if (!video || video.dataset.mediaHydrated) return;
      video.querySelectorAll('source[data-src]').forEach(source => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.mediaHydrated = 'true';
      video.load();
    }
    function syncVideo() {
      if (!video) return;
      if (active !== videoSlideIndex || document.hidden || !visible || reduce.matches || saveData) {
        video.pause();
        return;
      }
      hydrate();
      video.muted = true;
      video.play().catch(() => {});
    }
    function warmNext() {
      if (!automatic) return;
      const next = slides[(active + 1) % slides.length];
      next.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      if (video && next.contains(video) && !saveData) {
        video.preload = 'auto';
        hydrate();
      }
    }
    function schedule() {
      clearTimeout(timer);
      if (automatic && !focused && !document.hidden && visible) {
        timer = setTimeout(() => show(active + 1), Number(slides[active].dataset.duration) || 6000);
      }
    }
    function show(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== active;
        slide.inert = i !== active;
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
      root.dataset.activeSlide = String(active);
      root.dataset.activeCampaign = slides[active].dataset.campaign;
      warmNext();
      syncVideo();
      schedule();
    }
    dots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.lfCarouselDot))));
    root.addEventListener('focusin', event => {
      focused = !event.target.closest('[data-lf-carousel-dot]');
      schedule();
    });
    root.addEventListener('focusout', event => {
      if (!root.contains(event.relatedTarget)) { focused = false; schedule(); }
    });
    root.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      show(active + (event.key === 'ArrowRight' ? 1 : -1));
    });
    let start;
    root.addEventListener('pointerdown', event => {
      if (event.pointerType === 'touch' && !event.target.closest('a,button')) start = [event.clientX,event.clientY];
    });
    root.addEventListener('pointerup', event => {
      if (!start) return;
      const dx = event.clientX - start[0], dy = event.clientY - start[1];
      start = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) show(active + (dx < 0 ? 1 : -1));
    });
    root.addEventListener('pointercancel', () => { start = null; });
    if (video) video.addEventListener('playing', () => {
      video.closest('[data-lfm-cinematic]').classList.add('lf-cinematic--video-ready');
    });
    document.addEventListener('visibilitychange', () => { syncVideo(); schedule(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      syncVideo();
      schedule();
    }, { threshold: .15 }).observe(root);
    reduce.addEventListener('change', () => {
      automatic = !reduce.matches;
      warmNext();
      syncVideo();
      schedule();
    });
    show(0);
  }
  function initAll(scope = document) { scope.querySelectorAll('[data-lf-home-carousel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
